const getPageIdFromPath = (pathName: string): string => {
  const pageId = pathName.split("/").pop();
  if (pageId === undefined) {
    return "";
  }
  return pageId;
};

export default getPageIdFromPath;
